import "core-js/fn/promise"
import "core-js/es6/symbol"
import "core-js/es6/set"

import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import { currentFiscalYear } from '@/helpers/fiscalYear'

Vue.use(Vuex);

const apiBase = API_APP_PATH + "/v1";

export default new Vuex.Store({

  state: {
    teacher: {},
    role: "",
    employeeId: "",
    userName: "",
    schools: [],
    teachers: [],
    advisoryDisplay: false,
    fiscalYearSelected: currentFiscalYear()
  },

  mutations: {
    updateUser(state, data) {
      state.role = data.role;
      state.employeeId = data.employee_id;
      state.userName = data.user_id;
    },
    setSchools(state, schools) {
      state.schools = schools;
    },
    setTeachers(state, teachers) {
      state.teachers = teachers;
    },
    clearTeachers(state) {
      state.teachers = [];
    },
    updateBiogInfo(state, teacher) {
      state.teacher = teacher;
    },
    updateAdvisoryDisplay(state, advisoryDisplay) {
      state.advisoryDisplay = advisoryDisplay
    },
    updateFiscalYearSelected(state, fiscalYearSelected) {
      state.fiscalYearSelected = fiscalYearSelected
    }
  },

  actions: {
    async userInit({ commit }) {
      try {
        const { data: user } = await axios.get(`${apiBase}/app/orr`);
        commit("updateUser", user);
      } catch (e) {
        console.log(e);
      }
      return;
    },
    async fetchSchools({ commit, state, dispatch }) {
      try {
        if (state.employeeId) {
          const { data: schools } = await axios.get(
            `${apiBase}/data/admin/app/orr/info/schools/${state.employeeId}`
          );

          const _schools = schools.map(school => {
            school.display_name = `${school.school_dbn}: ${school.school_name}`;
            return school;
          });

          let years = [...new Set(_schools.map(schools => schools.FiscalYear))]

          commit("setSchools", _schools)
          commit('updateFiscalYearSelected', Math.max(...years))

          if (_schools.length === 1) {
            dispatch("fetchTeachers", _schools[0].school_dbn);
          }
        }
      } catch (e) {
        console.log(e);
      }
      return;
    },
    async fetchTeachers({ commit }, dbn) {
      try {
        const { data: teachers } = await axios.get(
          `${apiBase}/data/teacher/instructors/${dbn}`
        );
        const _teachers = teachers.map(t => {
          t.display_name = `${t.Last_Name}, ${t.First_Name}`;
          return t;
        });
        commit("setTeachers", _teachers);
      } catch (e) {
        console.log(e);
      }
      return;
    },
    clearTeachers({ commit }) {
      commit("clearTeachers");
    },
    async getBiogInfo({ commit }) {
      const response = await axios.get(
        `${apiBase}/teacher/evaluation/${state.employeeId}`
      );
      commit("updateBiogInfo", response.data[0]);
      return response;
    },
    switchAdvisory({commit}, value) {
      commit('updateAdvisoryDisplay', value)
    },
    changeFiscalYear({ commit }, fiscalYear) {
      commit("updateFiscalYearSelected", fiscalYear)
    }
  },

  getters: {
    getUserRole(state) {
      return state.role;
    },
    getUserId(state) {
      return state.employeeId;
    },
    getTeacherBiogInfo(state) {
      return state.teacher;
    },
    getSchoolsforDropdown(state) {
      return state.schools;
    },
    getTeachersforDropdown(state) {
      return state.teachers;
    },
    getTeacherById: state => id => {
      return state.teachers.find(teacher => teacher.EmployeeId === id);
    },
    getAdvisoryDisplay(state) {
      return state.advisoryDisplay;
    },
    getFiscalYearSelected(state) {
      return state.fiscalYearSelected;
    }
  }

});



// WEBPACK FOOTER //
// ./src/store/index.js